var React = require('react');

function SleepIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M60.2.84c33.137 0 60 26.863 60 60s-26.863 60-60 60-60-26.863-60-60 26.863-60 60-60zM49.134 34.058C37.713 39.41 30.132 50.756 31.323 63.513c1.297 13.906 12.375 24.92 26.36 26.21 12.42 1.145 23.007-6.21 29.137-16.613 1.147-1.946-.56-3.156-1.703-2.69a26.45 26.45 0 01-9.854 1.967 26.588 26.588 0 01-18.747-7.72 26.284 26.284 0 01-7.765-18.64c.02-3.645.807-7.233 2.3-10.538.396-.875-.35-2.166-1.917-1.431zM82.7 42.84c-1.346 3.51-2.99 5.154-6.5 6.5 3.51 1.347 5.154 2.99 6.5 6.5 1.347-3.51 2.99-5.153 6.5-6.5-3.51-1.347-5.154-2.99-6.5-6.5zm-14-10c-.932 2.43-2.07 3.568-4.5 4.5 2.43.932 3.568 2.07 4.5 4.5.932-2.43 2.07-3.568 4.5-4.5-2.43-.932-3.568-2.07-4.5-4.5z","fill":"#CDE6FC","fillRule":"evenodd"}));
}

SleepIcon.defaultProps = {"width":"121","height":"121"};

module.exports = SleepIcon;

SleepIcon.default = SleepIcon;
